<template>
	<div class="has-border is-marged-bottom" v-if="employees.length > 0">
		<h3 class="is-3 title is-marginless">{{ translations.title }}</h3>
		<p>
			{{ translations.intro }}
		</p>
		<table class="table is-hoverable is-fullwidth is-rowed">
			<thead>
			<tr>
				<th >
					{{ translations.list.first_name }}
				</th>
				<th >
					{{ translations.list.last_name }}
				</th>
				<th> </th>
			</tr>
			</thead>
			<tbody>
			<tr v-for="employee in employees">
				<td>
						{{ employee.userprofile.firstname }}
				</td>
				<td>
						{{ employee.userprofile.lastname }}
				</td>
				<td>
					<a class="button is-warning track-action"
					   @click="openCardTypeModal(employee.needActions.cardVirtual, employee.userprofile.firstname)"
					   v-if="employee.needActions.cardVirtual"
					   data-ta-event="clientarea-track.home.pending-employees.card"
					   data-ta-action="Click"
					   data-ta-label="Home-page - Click on pending employees' card link"
					   data-ta-page-name="Homepage"
					   :data-ta-payload="JSON.stringify({ 'cardId': employee.needActions.cardVirtual, 'first-name': employee.userprofile.firstname })"
					>
						{{ translations.list.card_type }}
					</a>

					<a class="button is-warning track-action"
					   @click="openEmailModal(employee.user_id, employee.userprofile.firstname)"
					   v-if="employee.needActions.emptyEmail"
					   data-ta-event="clientarea-track.home.pending-employees.email"
					   data-ta-action="Click"
					   data-ta-label="Home-page - Click on pending employees' email link"
					   data-ta-page-name="Homepage"
					   :data-ta-payload="JSON.stringify({ 'userId': employee.user_id, 'first-name': employee.userprofile.firstname })"
					>
						{{ translations.list.email }}
					</a>
				</td>
			</tr>
			</tbody>
		</table>
		<simple-modal @close="displayCardTypeModal = false" :display="displayCardTypeModal" :title="cardTypeModal.title">
			<template #default>
				<label class="label">
					{{ translations.card_type.label }}
				</label>
				<div class="control">
						<div class="radio" v-for="(value, key) in translations.card_type">
						<input
							class="is-checkradio"
							:id="key"
							:value="key"
							name="gender"
							type="radio"
							v-model="cardTypeModal.cardType"
						>
						<label :for="key">
							{{ value }}
							<span v-if="key !== 'virtual'">
								({{ orderData.cardPrice }} €)
							</span>
							<span v-else>
								({{ orderData.cardPriceVirtual }} €)
							</span>
						</label>

					</div>
				</div>
			</template>
			<template #footer>
				<div>
					<button class="button is-half is-success" @click="saveCardType">{{ translations.modals.buttons.save }}</button>
					<button class="button is-half is-danger" @click="displayCardTypeModal = false">{{ translations.modals.buttons.cancel }}</button>
				</div>
			</template>
		</simple-modal>
		<simple-modal @close="displayEmailModal = false" :display="displayEmailModal" :title="emailModal.title">
			<template #default>
				<flashes :alerts="alerts.data" v-if="alerts.action === 'modal'"></flashes>
				<label class="label">
					{{ translations.modals.email.label }}
				</label>
				<div class="control">
					<div class="field">
						<input class="input reset-input" v-model="emailModal.email" type="email" required>
					</div>
				</div>
			</template>
			<template #footer>
				<div>
					<button class="button is-half is-success" @click="saveEmail"> {{ translations.modals.buttons.save }}</button>
					<button class="button is-half is-danger" @click="displayEmailModal = false">{{ translations.modals.buttons.cancel }}</button>
				</div>
			</template>
		</simple-modal>
	</div>

</template>

<script>
	import {ApiMonizze} from '../api-monizze';

	export default {
		props: {
			getUrl: String,
			postUrl: String,
			translations: Object,
			orderData: Object,
			alerts: Object,
			logUrl: {
				type: String,
				required: false
			},
		},
		data ()
		{
			return {
				loader: true,
				employees: [],
				displayEmailModal: false,
				displayCardTypeModal: false,
				cardTypeModal: {
					cardId: null,
					cardType: null,
					title: null,
				},
				emailModal: {
					userId: null,
					email: null,
					title: null,
				},
			}
		},
		mounted() {
			this.getEmployees();
		},
		methods: {
			getEmployees: function()
			{

				this.loader = true;
				const api = new ApiMonizze();
				api.getDataFromApi(
					this.getUrl,
					(data, response) => {
						this.employees = data;
						this.loader = false;
					}
				);
			},
			openCardTypeModal:function (cardId, firstname)
			{
				this.displayCardTypeModal = true;
				this.cardTypeModal = {
					cardId: cardId,
					cardType: null,
					title: this.translations.modals.card_type.title.replace(':firstname', firstname),
				};
			},
			saveCardType: function ()
			{
				if(this.cardTypeModal.cardType === null)
				{
					return false;
				}
				const api = new ApiMonizze();
				let _this = this;
				api.postDataFromApi(
					_this.postUrl + '/cardType/' + _this.cardTypeModal.cardId,
					_this.cardTypeModal,
					function (data)
					{
						_this.displayCardTypeModal = false;
						_this.getEmployees();
					}
				);
			},
			openEmailModal: function (userId, firstname)
			{
				this.displayEmailModal = true;
				this.emailModal = {
					userId: userId,
					email: null,
					title: this.translations.modals.card_type.title.replace(':firstname', firstname),
				};
			},
			saveEmail: function ()
			{
				if(this.emailModal.email === null)
				{
					return false;
				}
				const api = new ApiMonizze();
				let _this = this;
				api.postDataFromApi(
					_this.postUrl + '/' + _this.emailModal.userId + '/email',
					_this.emailModal,
					function (data)
					{
						_this.displayEmailModal = false;
						_this.getEmployees();
					}
				);
			}
		}
	}
</script>

<style scoped>

</style>
